// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Timer from "../Effect.Timer/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var asyncRequest = /* #__PURE__ */ Specular_FRP_Async.asyncRequest(Specular_Dom_Builder.monadEffectBuilder)(monadFRP);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var dynamic_ = /* #__PURE__ */ Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(monadFRP);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Specular_FRP_Base.functorEvent);
var $$void = /* #__PURE__ */ Data_Functor["void"](Specular_FRP_Base.functorEvent);
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt);
var withPrevious = function (dictMonadFRP) {
    var bind1 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var readDynamic = Specular_FRP_Base.readDynamic(dictMonadFRP.MonadEffect0());
    var foldDyn = Specular_FRP_Base.foldDyn(dictMonadFRP);
    return function (source) {
        return bind1(readDynamic(source))(function (initial) {
            return foldDyn(function ($$new) {
                return function (old) {
                    return {
                        previous: new Data_Maybe.Just(old.current),
                        current: $$new
                    };
                };
            })({
                previous: Data_Maybe.Nothing.value,
                current: initial
            })(Specular_FRP_Base.changed(source));
        });
    };
};
var withLoadedSuccessE$prime = function (loader) {
    return function (errorHandler) {
        return function (request) {
            return function (handler) {
                var req = Control_Monad_Except_Trans.runExceptT(request);
                return bind(asyncRequest(pure(req)))(function (result) {
                    return dynamic_(mapFlipped(result)(function (v) {
                        if (v instanceof Specular_FRP_Async.NotRequested) {
                            return pure1(Data_Unit.unit);
                        };
                        if (v instanceof Specular_FRP_Async.Loading) {
                            return loader;
                        };
                        if (v instanceof Specular_FRP_Async.Loaded && v.value0 instanceof Data_Either.Left) {
                            return errorHandler(v.value0.value0);
                        };
                        if (v instanceof Specular_FRP_Async.Loaded && v.value0 instanceof Data_Either.Right) {
                            return handler(v.value0.value0);
                        };
                        throw new Error("Failed pattern match at Specular.Extra (line 44, column 5 - line 48, column 36): " + [ v.constructor.name ]);
                    }));
                });
            };
        };
    };
};
var withLoadedSuccessE = /* #__PURE__ */ withLoadedSuccessE$prime(/* #__PURE__ */ pure1(Data_Unit.unit));
var withLoadedSuccess$prime = function (loader) {
    return function (errorHandler) {
        return function (request) {
            return function (handler) {
                return bind(asyncRequest(pure(request)))(function (result) {
                    return dynamic_(mapFlipped(result)(function (v) {
                        if (v instanceof Specular_FRP_Async.NotRequested) {
                            return pure1(Data_Unit.unit);
                        };
                        if (v instanceof Specular_FRP_Async.Loading) {
                            return loader;
                        };
                        if (v instanceof Specular_FRP_Async.Loaded && v.value0 instanceof Data_Either.Left) {
                            return errorHandler(v.value0.value0);
                        };
                        if (v instanceof Specular_FRP_Async.Loaded && v.value0 instanceof Data_Either.Right) {
                            return handler(v.value0.value0);
                        };
                        throw new Error("Failed pattern match at Specular.Extra (line 28, column 5 - line 32, column 36): " + [ v.constructor.name ]);
                    }));
                });
            };
        };
    };
};
var unlinesWidget = /* #__PURE__ */ (function () {
    var $55 = Data_Foldable.sequence_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray);
    var $56 = Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidArray)([ Specular_Dom_Element.el_("br")(Restaumatic_Prelude_Specular.wempty) ]);
    var $57 = map(Control_Applicative.pure(Control_Applicative.applicativeArray));
    return function ($58) {
        return $55($56($57($58)));
    };
})();
var times = "\xd7";
var timesIcon = /* #__PURE__ */ Specular_Dom_Element.text(times);
var simpleErrorWidget = function (err) {
    return discard(Specular_Dom_Element.text("Error loading data"))(function () {
        return Specular_Dom_Element.el_("pre")(Specular_Dom_Element.text(err));
    });
};
var withLoadedSuccess = /* #__PURE__ */ withLoadedSuccess$prime(/* #__PURE__ */ pure1(Data_Unit.unit))(simpleErrorWidget);
var nbsp = /* #__PURE__ */ Specular_Dom_Element.text("\xa0");
var launchDelayed = /* #__PURE__ */ (function () {
    var $59 = Effect_Class.liftEffect(Effect_Class.monadEffectEffect);
    var $60 = Data_Functor["void"](Effect.functorEffect);
    var $61 = Effect_Timer.setTimeout(0);
    return function ($62) {
        return $59($60($61($62)));
    };
})();
var detectNEvents = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var foldDyn = Specular_FRP_Base.foldDyn(dictMonadFRP);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (n) {
        return function (e) {
            return bind1(foldDyn(add)(0)(voidRight(1)(e)))(function (count) {
                return pure2($$void(Specular_FRP_Base.filterEvent(function (n$prime) {
                    return mod(n$prime)(n) === 0;
                })(Specular_FRP_Base.changed(count))));
            });
        };
    };
};
var delayWidget = function (fn) {
    return bind(pure1(Data_Unit.unit))(fn);
};
var classesFromString = /* #__PURE__ */ (function () {
    var $63 = Data_Array.filter((function () {
        var $67 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        return function ($68) {
            return $67(Data_String_Common["null"]($68));
        };
    })());
    var $64 = map(Data_String_Common.trim);
    var $65 = Data_String_Common.split(" ");
    return function ($66) {
        return Specular_Dom_Element.classes($63($64($65($66))));
    };
})();
export {
    focusElement,
    focusNode
} from "./foreign.js";
export {
    withLoadedSuccess,
    withLoadedSuccess$prime,
    withLoadedSuccessE,
    withLoadedSuccessE$prime,
    simpleErrorWidget,
    withPrevious,
    nbsp,
    times,
    timesIcon,
    unlinesWidget,
    classesFromString,
    detectNEvents,
    delayWidget,
    launchDelayed
};
